function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useMemo } from 'react';
import { matchSorter } from 'match-sorter';
import { Autocomplete, Typography } from 'seagull';
import { Plus } from 'seagull/icons';
import { getPMDetails } from "../pm.utils";
import styles from "./PMCompanyDropdown.module.scss";
import { OptionType } from "./PMCompanyDropdown.utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function PMCompanyDropdown(props) {
  const {
    companies,
    value,
    onChange: _onChange,
    textFieldProps = {},
    loading = false,
    disabled = false,
    onInputFocus,
    onInputBlur,
    pmType
  } = props;
  const createNewOption = {
    type: OptionType.CreateNew
  };
  const pmDetails = getPMDetails(pmType);
  const options = useMemo(() => {
    const options = companies.slice().sort((a, b) => a.companyName.localeCompare(b.companyName)).map(c => ({
      type: OptionType.Existing,
      company: c
    }));
    options.unshift(createNewOption);
    return options;
  }, [companies]);
  return /*#__PURE__*/_jsx(Autocomplete, {
    helperText: "test",
    collapseHelperText: false,
    testId: "pm-company-dropdown",
    value: value,
    options: options,
    onChange: (_, newOption) => _onChange(newOption),
    disabled: disabled,
    renderOption: option => {
      if ((option === null || option === void 0 ? void 0 : option.type) === OptionType.CreateNew) {
        return /*#__PURE__*/_jsxs(Typography, {
          skin: "link",
          className: styles.newCompanyOption,
          children: [/*#__PURE__*/_jsx(Plus, {}), "Push as a new ", pmDetails.company, " to ", pmDetails.name]
        });
      } else {
        return /*#__PURE__*/_jsx(Typography, {
          ellipsis: true,
          testId: "company-name",
          children: option.company.companyName
        });
      }
    },
    getOptionLabel: option => {
      switch (option === null || option === void 0 ? void 0 : option.type) {
        case OptionType.CreateNew:
          {
            return "Push as a new ".concat(pmDetails.company);
          }
        case OptionType.Existing:
          {
            return option.company.companyName;
          }
      }
    },
    getOptionSelected: (option, value) => {
      if (!value) return false;
      const isExistingCustomerType = option.type === OptionType.Existing && value.type === OptionType.Existing;
      const existingSelected = isExistingCustomerType && option.company.companyId === value.company.companyId;
      const isNewCustomerType = option.type === OptionType.CreateNew && value.type === OptionType.CreateNew;
      return existingSelected || isNewCustomerType;
    },
    filterOptions: (options, _ref) => {
      let {
        inputValue
      } = _ref;
      const filtered = matchSorter(options, inputValue, {
        keys: [opt => opt.type === OptionType.Existing ? [opt.company.companyName] : []]
      });
      filtered.unshift(createNewOption);
      return filtered;
    },
    noOptionsText: "No ".concat(pmDetails.company, " found"),
    loading: loading,
    textFieldProps: _objectSpread({
      placeholder: "Select ".concat(pmDetails.company)
    }, textFieldProps),
    disableTyping: (value === null || value === void 0 ? void 0 : value.type) === OptionType.CreateNew,
    selectOnFocus: true,
    disableClearable: false,
    multiple: false,
    freeSolo: false,
    onFocus: onInputFocus,
    onBlur: onInputBlur
  });
}